<template>
  <v-dialog v-model="dialogValue" persistent max-width="380">
    <v-card>
      <v-card-title class="text-primary text-h5">
        {{ dialogTitle }}
      </v-card-title>
      <v-card-text class="text-primary text-justify">
        <span v-html="dialogConfirm" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="rounded-2"
          color="primary"
          variant="flat"
          @click="dialogValue = false"
        >
          <div
            class="text-subtitle-2 text-white text-truncate font-weight-bold px-3"
          >
            Cancel
          </div>
        </v-btn>
        <v-btn
          class="rounded-2"
          color="warning"
          variant="flat"
          :loading="loadingDelete"
          :disabled="loadingDelete"
          @click="handleDelete"
        >
          <div
            class="text-subtitle-2 text-white text-truncate font-weight-bold px-3"
          >
            Delete
          </div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/Core.Service.Domain/ViewSupport/Reports/API/index.js';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ConfirmDialogDeleteScheduledReports',

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    scheduledReportInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loadingDelete: false,
    };
  },

  computed: {
    ...mapGetters({
      defaultSite: 'session/defaultSite',
    }),

    dialogValue: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('update:dialog', value);
      },
    },

    dialogTitle() {
      return 'Delete this Scheduled Report';
    },

    dialogConfirm() {
      return `Are you sure you want to delete <strong>${this.scheduledReportInfo.name}</strong> and its associated data? Deleting a Scheduled Report cannot be undone.`;
    },
  },

  methods: {
    ...mapActions({
      setScheduledReportsList:
        'ViewSupportStore/ReportsStore/setScheduledReportsList',
    }),

    async handleDelete() {
      const { id } = this.scheduledReportInfo;
      try {
        this.loadingDelete = true;
        await API.deleteScheduledReport(id);
        this.setScheduledReportsList();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.dialogValue = false;
        this.loadingDelete = false;
      }
    },
  },
};
</script>
